function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getCookie, setCookie } from 'typescript-cookie';
import { v1 as uuid } from 'uuid';
import { trackPageView, SessionTracker } from '../../tracker';
import { getDomain } from '../../utils';
import { PinPointClient } from './aws-pinpoint';
import { EventBuffer } from './event-buffer';
export class AwsAnalyticProvider {
  constructor(authConfig, pinpointConfig) {
    _defineProperty(this, "authConfig", void 0);
    _defineProperty(this, "pinpointConfig", void 0);
    _defineProperty(this, "pinPointClient", void 0);
    _defineProperty(this, "eventBuffer", void 0);
    _defineProperty(this, "endpointId", void 0);
    _defineProperty(this, "sessionTracker", void 0);
    _defineProperty(this, "record", async event => {
      const awsEvent = this.withSession({
        ...event,
        eventId: uuid(),
        timestamp: new Date().getTime(),
        endpointId: this.getEndpointId()
      });
      await this.pinPointClient.init();
      this.eventBuffer.push(awsEvent);
    });
    this.authConfig = authConfig;
    this.pinpointConfig = pinpointConfig;
    this.pinPointClient = new PinPointClient(this.authConfig, this.pinpointConfig);
    this.eventBuffer = new EventBuffer(this.pinPointClient);
    this.sessionTracker = new SessionTracker();
  }
  async autoTrack(trackerType, config) {
    if (trackerType === 'pageView') {
      trackPageView(this.record, config);
    }
    this.sessionTracker.trackSession(this.record);
  }
  async updateEndpoint(endpoint) {
    await this.pinPointClient.init();
    await this.pinPointClient.updateEndpoint(this.pinpointConfig.appId, this.getEndpointId(), {
      channelType: 'APNS',
      // Pinpoint will remove the oldest push endpoint when endpoints for a user exceeded 15.
      ...endpoint
    });
  }
  getEndpointId() {
    var _this$pinpointConfig;
    if (this.endpointId) {
      return this.endpointId;
    }
    const cacheKey = `AWS-analytic-${(_this$pinpointConfig = this.pinpointConfig) === null || _this$pinpointConfig === void 0 ? void 0 : _this$pinpointConfig.appId}`;
    const cachedEndpointId = getCookie(cacheKey);
    if (cachedEndpointId) {
      return cachedEndpointId;
    }
    const newEndpointId = uuid();
    setCookie(cacheKey, newEndpointId, {
      domain: getDomain(),
      secure: true,
      expires: 365
    });
    this.endpointId = newEndpointId;
    return newEndpointId;
  }
  withSession(event) {
    return {
      ...event,
      session: this.sessionTracker.getOrStartSession()
    };
  }
}